'use client'

import SidebarTrigger from '@/components/Sidebar/Trigger/SidebarTrigger'

import styles from './MenuHeaderDefault.module.scss'
import { useEffect, useState } from 'react'
import AppContext from '@/types/context'
import { DeviceType } from '@/utils/app/detect'

const SidebarTriggerBtn = ({ context }: { context: AppContext }) => {
  const [triggerOverlapping, setTriggerOverlapping] = useState<boolean>(context.device?.type === DeviceType.MOBILE)

  useEffect(() => {
    const checkOverlap = () => {
      const banner = document.getElementById('widget-menu-header-default')?.getBoundingClientRect()
      const trigger = document.getElementById('widget-menu-tab-navigation-sidebar-trigger')?.getBoundingClientRect()

      if (!trigger) {
        setTriggerOverlapping(true)
        return
      }
      if (banner && trigger) {
        const bannerSentinel = banner.top + banner.height
        const triggerSentinel = trigger.top + trigger.height - 4

        const isOverlapping = bannerSentinel >= triggerSentinel
        setTriggerOverlapping(isOverlapping)
      }
    }
    checkOverlap()

    context.device?.type !== DeviceType.MOBILE && window.addEventListener('scroll', checkOverlap)

    return () => {
      window.removeEventListener('scroll', checkOverlap)
    }
  }, [])

  return triggerOverlapping && <SidebarTrigger sidebarId="main" className={styles['sidebar-trigger']} size={28} />
}

export default SidebarTriggerBtn
